import { z } from 'zod';
import { supportContractLimits, supportRequestCategorySchema, supportOpaqueIdSchema, } from './common.js';
/** The exact credentialless public intake body. Unknown fields fail closed. */
export const supportRequestInputSchema = z
    .object({
    submissionId: supportOpaqueIdSchema,
    name: z.string().trim().min(1).max(supportContractLimits.name),
    email: z.string().trim().toLowerCase().max(supportContractLimits.email).pipe(z.email()),
    category: supportRequestCategorySchema,
    message: z
        .string()
        .trim()
        .min(supportContractLimits.messageMin)
        .max(supportContractLimits.messageMax),
})
    .strict();
export const supportRequestInputFields = Object.freeze(Object.keys(supportRequestInputSchema.shape));
/** A durable receipt exposes one opaque ID and no submitted or internal information. */
export const supportRequestReceiptSchema = z
    .object({
    requestId: supportOpaqueIdSchema,
    status: z.literal('received'),
})
    .strict();
export const supportRequestReceiptFields = Object.freeze(Object.keys(supportRequestReceiptSchema.shape));
//# sourceMappingURL=public.js.map